<div class="simulation-info-page">
  <app-header/>

  <main class="simulation-info-content">
    <div class="content-box">
      <h2 class="box-title">Cotas Contempladas</h2>
      <app-leads-table
        [hasFilterTrigger]="false"
        [availableOrigins]="availableFilterOrigins"
        [showStatusIcon]="false"
        [columns]="tableColumns"
        [data]="tableData"
        [filterConfig]="filterConfig"
        [serverSidePagination]="serverSidePagination"
        [loading]="loading"
        [emptyMessage]="emptyMessage"
        [errorMessage]="errorMessage"
        [viewButtonTracking]="{
          trackEvent: 'visualizar_assinaturas',
          trackCategory: 'assinaturas',
          trackLabel: 'view_assinatura'
        }"
        (pageChange)="onPageChange($event)"
        (pageSizeChange)="onPageSizeChange($event)"
        (viewLeadClick)="onViewLead($event)"
        (searchChange)="onSearchChange($event)"
        (filterChange)="onFilterChange($event)"
        (dateRangeChange)="onDateRangeChange($event)"
        (clearAllFilters)="onClearAllFilters()"
        (sortChange)="onSortChange($event)"/>
    </div>
  </main>
</div>
